import { $themeConfig } from "@themeConfig";
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import router from "../../router";
import app from "@/main";
import { Promise } from "core-js";
import { GetBookingDetail } from "@/api/wr1-mybooking";
let initialState = {
  vip_types: [],
  regions: [],
  countries: [],
  users: [],
  companyItems: [],
  companyItemsName: [],
  sales: [],
  banks: [],
  LocationTypes: [],
  exchangeRate: [],
  service_types: [],
  ports: [],
  incoterms: [],
  locations: [],
  deports_locations: [],
  cont_types: [],
  goods_types: [],
  transport_types: [],
  deports: [],
  business_types: [],
  customs_types: [],
  shipping_lines: [],
  fee_types: [],
  acc_dept: [],
  customer_list_options: [],
  handed_types: [],
  vessel: [],
  catelogy: [],
  quotations: [],
  shippingDetails: null,
  truckList: [],
  booking_detail: null,
};
export default {
  namespaced: true,
  state: {
    vip_types: [],
    regions: [],
    countries: [],
    users: [],
    companyItems: [],
    companyItemsName: [],
    sales: [],
    banks: [],
    menu: null,
    LocationTypes: [],
    exchangeRate: [],
    service_types: [],
    ports: [],
    incoterms: [],
    locations: [],
    deports_locations: [],
    cont_types: [],
    goods_types: [],
    transport_types: [],
    deports: [],
    business_types: [],
    customs_types: [],
    shipping_lines: [],
    fee_types: [],
    acc_dept: [],
    customer_list_options: [],
    handed_types: [],
    vessel: [],
    catelogy: [],
    quotations: [],
    shippingDetails: null,
    truckList: [],
    booking_detail: null,
    locationPickUp: [],
    locationDelivery: [],
    locationByUser: [],
  },
  getters: {
    getLocationTypes: (state) => {
      return formatOption(state.LocationTypes);
    },
    exchangeRate: (state) => {
      return state.exchangeRate.value;
    },
  },
  mutations: {
    SET_VIP(state, payload) {
      state.vip_types = payload;
    },
    SET_SHIPPING_DETAIL(state, payload) {
      state.shippingDetails = payload;
    },
    RESET_STATE(state, payload) {
      for (let f in state) {
        if (initialState[f]) {
          Vue.set(state, f, initialState[f]);
        }
      }
    },
    FETCH_CUSTOMER_LIST_COMPANY(state, payload) {
      state.customer_list_options = payload;
    },
    FETCH_REGION(state, payload) {
      state.regions = payload;
    },
    FETCH_COUNTRIES(state, payload) {
      state.countries = payload;
    },
    FETCH_USER(state, payload) {
      state.users = payload;
    },
    FETCH_COMPANY_ITEMS(state, payload) {
      state.companyItems = payload;
    },
    FETCH_COMPANY_ITEMS_NAME(state, payload) {
      state.companyItemsName = payload;
    },
    FETCH_SALES(state, payload) {
      state.sales = payload;
    },
    FETCH_BANK(state, payload) {
      state.banks = payload;
    },
    SET_MENU(state, payload) {
      state.menu = payload;
    },
    SET_LocationTypes(state, payload) {
      state.LocationTypes = payload;
    },
    FETCH_RATE(state, payload) {
      state.exchangeRate = payload;
    },
    SET_SERVICE_TYPE(state, payload) {
      state.service_types = payload;
    },
    SET_PORT(state, payload) {
      state.ports = payload;
    },
    SET_QUOTATION_BOOKING(state, payload) {
      state.quotations = payload;
    },
    SET_INCOTERMS(state, payload) {
      state.incoterms = payload;
    },
    SET_LOCATION(state, payload) {
      state.locations = payload;
    },
    SET_DEPORTS_LOCATION(state, payload) {
      state.deports_locations =
        // payload;
        payload.filter((item) => [1, 2, 3].includes(item.location_type_id));
    },
    SET_CONT_TYPE(state, payload) {
      state.cont_types = payload;
    },
    SET_GOOD_TYPE(state, payload) {
      state.goods_types = payload;
    },

    SET_TRANSPORT_TYPES(state, payload) {
      state.transport_types = payload;
    },
    SET_DEPORT(state, payload) {
      state.deports = payload;
    },

    SET_BUSINESS_TYPE(state, payload) {
      state.business_types = payload;
    },
    SET_CUSTOMS_TYPE(state, payload) {
      state.customs_types = payload;
    },
    SET_SHIPPING_TYPE(state, payload) {
      state.shipping_lines = payload;
    },
    SET_FEE_TYPE(state, payload) {
      state.fee_types = payload;
    },
    SET_ACC_DEPT(state, payload) {
      state.acc_dept = payload;
    },
    SET_HANDLER_TYPE(state, payload) {
      state.handed_types = payload;
    },
    SET_VESSEL_TYPE(state, payload) {
      state.vessel = payload;
    },
    FETCH_LOCATION_USER_HANDLING_TYPE_LOCATION_TYPE_PICK_UP(state, payload) {
      state.locationPickUp = payload;
    },
    FETCH_LOCATION_USER_HANDLING_TYPE_LOCATION_TYPE_DELIVERY(state, payload) {
      state.locationDelivery = payload;
    },
    FETCH_LOCATION_USER(state, payload) {
      state.locationByUser = payload;
    },
    // truckList:[]
    SET_TRUCK_LIST(state, payload) {
      state.truckList = payload;
    },

    SET_BOOKING_DETAIL(state, payload) {
      state.booking_detail = payload;
    },
  },

  actions: {
    async fetchDetailBooking({ commit, state }, id) {
      try {
        const data = await GetBookingDetail({ id });
        if (data && data?.shipment_detail) {
          var shipment = JSON.parse(data?.shipment_detail);

          if (shipment) {
            var truckList = [];
            if (shipment.service_type?.toString() == "5") {
              shipment?.valueContainer?.forEach((item, idx) =>
                item?.containerLine3?.forEach((truck, ix) =>
                  truckList.push({
                    id: truck.truckId,
                    value: truck.truckId,
                  })
                )
              );
            } else if (shipment.service_type?.toString() == "6") {
              shipment?.valueVan?.forEach((item, idx) =>
                item?.vanLine3?.forEach((truck, ix) =>
                  truckList.push({
                    id: truck.truckId,
                    value: truck.truckId,
                  })
                )
              );
            } else if (shipment.service_type?.toString() == "3") {
              shipment?.showAddMore?.forEach((item, idx) =>
                item?.lclLine3?.forEach((truck, ix) =>
                  truckList.push({
                    id: truck.truckId,
                    value: truck.truckId,
                  })
                )
              );
            }

            //truckId
            commit("SET_TRUCK_LIST", truckList);
          }

          commit("SET_BOOKING_DETAIL", data);
        }
      } catch (error) {
        console.log(error);
      }
    },
    fetchLocationByUser({ commit, state }, n) {
      useJwt
        .get("masterData?data=Location", {
          params: {
            search: {
              customer_id: n.customer_id,
            },
          },
        })
        .then((response) => {
          commit("FETCH_LOCATION_USER", formatOption(response.data.result));
        })
        .catch((error) => {
          app.$toast({
            component: ToastificationContent,
            props: {
              title: "Something went wrong, please try again",
              icon: "CheckSquareIcon",
              variant: "danger",
            },
          });
        });
    },

    fetchLocationByUserHandlingTypeLocationTypePickUp({ commit, state }, n) {
      commit("FETCH_LOCATION_USER_HANDLING_TYPE_LOCATION_TYPE_PICK_UP", []);
      commit("FETCH_LOCATION_USER_HANDLING_TYPE_LOCATION_TYPE_DELIVERY", []);
      useJwt
        .get("masterData?data=Location", {
          params: {
            search: {
              customer_id: n.customer_id,
              handling_type_id: n.handling_type_id,
              location_type: n.location_type,
              tax_code: n.tax_code,
            },
          },
        })
        .then((response) => {
          if (n.location_type == "PICK_UP") {
            commit(
              "FETCH_LOCATION_USER_HANDLING_TYPE_LOCATION_TYPE_PICK_UP",
              formatOption(response.data.result)
            );
          } else {
            commit(
              "FETCH_LOCATION_USER_HANDLING_TYPE_LOCATION_TYPE_DELIVERY",
              formatOption(response.data.result)
            );
          }
        })
        .catch((error) => {
          app.$toast({
            component: ToastificationContent,
            props: {
              title: "Something went wrong, please try again",
              icon: "CheckSquareIcon",
              variant: "danger",
            },
          });
        });
    },

    fetchVip({ commit, state }) {
      if (state.vip_types.length == 0) {
        useJwt
          .get("masterData?data=CustomerLevel")
          .then((response) => {
            commit("SET_VIP", formatOption(response.data.result));
          })
          .catch((error) => {
            app.$toast({
              component: ToastificationContent,
              props: {
                title: "Something went wrong, please try again",
                icon: "CheckSquareIcon",
                variant: "danger",
              },
            });
          });
      }
    },

    fetchRegion({ commit, state }) {
      return useJwt
        .get("masterData?data=Region")
        .then((response) => {
          commit("FETCH_REGION", formatOption(response.data.result));
        })
        .catch((error) => {
          app.$toast({
            component: ToastificationContent,
            props: {
              title: "Something went wrong, please try again",
              icon: "CheckSquareIcon",
              variant: "danger",
            },
          });
        });
    },

    fetchCountries({ commit, state }) {
      if (state.countries.length == 0) {
        useJwt.get("masterData?data=Country").then((response) => {
          commit("FETCH_COUNTRIES", formatOption(response.data.result));
        });
      }
    },
    fetchUsers({ commit, state }) {
      if (state.users.length == 0) {
        useJwt
          .get("userList", {
            params: {
              search: "",
              page: 1,
              pageSize: 10000,
            },
          })
          .then((response) => {
            const data = response.data.result;
            const mapData = data
              .map((obj) => {
                obj.text = obj.user_id + " - " + obj.full_name || "";
                if (obj.status == 1) return obj;
              })
              .filter(function (element) {
                return element !== undefined;
              });
            commit("FETCH_USER", mapData);
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Something went wrong, please try again",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
      }
    },
    fetchCompany: function ({ commit, state }) {
      return new Promise((resolve, reject) => {
        useJwt
          .get("masterData?data=Company", {})
          .then((response) => {
            var mapCompany = response.data.result.map((obj) => {
              obj.text = obj.code + " - " + obj.text || obj.name;
              obj.id = obj.code;
              obj.Acronym = obj.acronym;
              return obj;
            });

            commit("FETCH_COMPANY_ITEMS", mapCompany);
            commit("FETCH_COMPANY_ITEMS_NAME", mapCompany);
            resolve(mapCompany);
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Something went wrong, please try again",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
      });
    },
    fetchSaler: function ({ commit, state }) {
      if (state.sales.length == 0) {
        useJwt.get("masterData?data=Saler", {}).then((response) => {
          commit("FETCH_SALES", formatOption(response.data.result));
        });
      }
    },
    fetchBank({ commit, state }) {
      if (state.banks.length == 0) {
        useJwt
          .get("masterData", { params: { data: "Bank" } })
          .then((response) => {
            const mapBanks = response.data.result.map((obj) => {
              obj.text = obj.code + " | " + obj.name;
              obj.id = obj.code;
              return obj;
            });

            commit("FETCH_BANK", mapBanks);
          })
          .catch((error) => {});
      }
    },
    fetchMenu({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.menu == null || state.menu.length == 0) {
          useJwt
            .get("masterData", { params: { data: "menu" } })
            .then((response) => {
              commit("SET_MENU", response.data.result);
              resolve(response.data.result);
            })
            .catch((error) => {
              localStorage.removeItem("userData");
              localStorage.removeItem("area");
              commit("SET_MENU", null);
              resolve(false);
            });
        } else {
          resolve(state.menu);
        }
      });
    },
    fetchLocationTypes({ commit, state }) {
      if (state.LocationTypes.length == 0) {
        return new Promise((resolve, reject) => {
          useJwt
            .get("masterData", {
              params: { data: "LocationTypes" },
            })
            .then((response) => {
              commit("SET_LocationTypes", response.data.result);
              resolve(response.data.result);
            })
            .catch((error) => {
              resolve(false);
            });
        });
      }
    },
    fetchServiceTypes({ commit, state }) {
      if (state.service_types.length == 0) {
        return new Promise((resolve, reject) => {
          useJwt
            .get("masterData", { params: { data: "ServiceType" } })
            .then((response) => {
              commit("SET_SERVICE_TYPE", response.data.result);
              resolve(response.data.result);
            })
            .catch((error) => {
              resolve(false);
            });
        });
      }
    },

    fetchCustomerListCompany({ commit }, n) {
      useJwt
        .get("wr1?objectType=CustomerListCompany", {
          params: { search: n },
        })
        .then((response) => {
          commit(
            "FETCH_CUSTOMER_LIST_COMPANY",
            formatOption(response.data.result)
          );
        });
    },
    fetchRate({ commit, state }) {
      if (state.exchangeRate.length == 0) {
        useJwt.get("masterData?data=SystemConfig").then((response) => {
          commit(
            "FETCH_RATE",
            response.data.result.filter((e) => e.code == "EXCHANGE_RATE")[0]
          );
        });
      }
    },
    fetchPort({ commit, state }) {
      return useJwt.get("masterData?data=Port").then((response) => {
        commit("SET_PORT", formatOption(response.data.result));
      });
    },
    fetchQuotationBooking({ commit, state }) {
      if (state.quotations.length == 0) {
        useJwt.get("wr1?objectType=GetQuotationBooking").then((response) => {
          commit("SET_QUOTATION_BOOKING", formatOption(response.data.result));
        });
      }
    },
    fetchIncoterm({ commit, state }) {
      if (state.incoterms.length == 0) {
        useJwt.get("masterData?data=Incoterm").then((response) => {
          commit("SET_INCOTERMS", formatOption(response.data.result));
        });
      }
    },
    fetchLocations({ commit, state }) {
      commit("SET_LOCATION", []);

      return useJwt.get("masterData?data=Location").then((response) => {
        commit("SET_LOCATION", response.data.result);
        commit("SET_DEPORTS_LOCATION", response.data.result);
      });
    },
    fetchContType({ commit, state }) {
      if (state.cont_types.length == 0) {
        useJwt.get("masterData?data=ContType").then((response) => {
          commit("SET_CONT_TYPE", formatOption(response.data.result));
        });
      }
    },
    fetchGoodsType({ commit, state }) {
      if (state.goods_types.length == 0) {
        useJwt.get("masterData?data=GoodsType").then((response) => {
          commit("SET_GOOD_TYPE", response.data.result);
        });
      }
    },
    fetchTransportsType({ commit, state }) {
      if (state.transport_types.length == 0) {
        useJwt.get("masterData?data=TransportType").then((response) => {
          commit("SET_TRANSPORT_TYPES", response.data.result);
        });
      }
    },

    fetchDeport({ commit, state }) {
      if (state.deports.length == 0) {
        useJwt.get("masterData?data=Deport").then((response) => {
          commit("SET_DEPORT", response.data.result);
        });
      }
    },
    fetchBusinessType({ commit, state }) {
      if (state.business_types.length == 0) {
        useJwt.get("masterData?data=BusinessType").then((response) => {
          commit("SET_BUSINESS_TYPE", response.data.result);
        });
      }
    },

    fetchCustomsType({ commit, state }) {
      if (state.customs_types.length == 0) {
        useJwt.get("masterData?data=CustomsType").then((response) => {
          commit("SET_CUSTOMS_TYPE", response.data.result);
        });
      }
    },

    fetchFeeType({ commit, state }) {
      if (state.fee_types.length == 0) {
        useJwt.get("masterData?data=FeeType").then((response) => {
          commit("SET_FEE_TYPE", response.data.result);
        });
      }
    },

    fetchHandedType({ commit, state }) {
      if (state.handed_types.length == 0) {
        useJwt.get("masterData?data=HandedType").then((response) => {
          commit("SET_HANDLER_TYPE", response.data.result);
        });
      }
    },
    fetchVessel({ commit, state }) {
      if (state.vessel.length == 0) {
        useJwt.get("masterData?data=Vessel").then((response) => {
          commit("SET_VESSEL_TYPE", response.data.result);
        });
      }
    },

    fetchShippingLine({ commit, state }) {
      if (state.shipping_lines.length == 0) {
        return useJwt.get("masterData?data=ShippingLine").then((response) => {
          const data = response.data.result;
          const mapData = data.map((obj) => {
            obj.text = obj.code + " - " + obj.name || "";
            return obj;
          });

          commit("SET_SHIPPING_TYPE", mapData);
        });
      }
    },
    fetchPortsType({ commit }) {
      return new Promise((resolve, reject) => {
        useJwt.get("fast?objectType=Airports").then((response) => {
          resolve(response.data);
        });
      });
    },

    fetchShipperType({ commit }) {
      return useJwt.get("fast?objectType=Partners").then((response) => {
        return response.data;
      });
    },
    fetchAccDept({ commit, state }) {
      if (state.acc_dept.length == 0) {
        return useJwt.get("masterData?data=AccDept").then((response) => {
          commit("SET_ACC_DEPT", response.data.result);
        });
      }
    },
    FETCH_ALL: ({ dispatch }) => {
      // Dispatch all the actions here
      dispatch("fetchRegion");

      dispatch("fetchServiceTypes");
      dispatch("fetchPort");
      dispatch("fetchQuotationBooking");
      dispatch("fetchIncoterm");
      dispatch("fetchContType");

      dispatch("fetchGoodsType");

      dispatch("fetchTransportsType");

      // dispatch('fetchDeport');

      dispatch("fetchBusinessType");

      dispatch("fetchCustomsType");
      dispatch("fetchShippingLine");
      dispatch("fetchFeeType");
      dispatch("fetchCompany");
      dispatch("fetchHandedType");
      dispatch("fetchVessel");

      dispatch("fetchLocations");

      dispatch("fetchSaler");
      dispatch("fetchRate");

      dispatch("fetchAccDept");

      dispatch("fetchVip");

      //...
    },
  },
};

function formatOption(arr) {
  const mapData = arr.map((obj) => {
    obj.text = obj.text || obj.name;
    obj.id = obj.code || obj.id;
    return obj;
  });
  return mapData;
}
